/**
 * @generated SignedSource<<69aa819ad44b92256460fd1c5f21cbfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type linkUnit4ProjectModal_Query$variables = {};
export type linkUnit4ProjectModal_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"linkUnit4ProjectModal_viewer">;
  } | null;
};
export type linkUnit4ProjectModal_Query = {
  variables: linkUnit4ProjectModal_Query$variables;
  response: linkUnit4ProjectModal_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "link_unit4_project_modal"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"link_unit4_project_modal\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "linkUnit4ProjectModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "linkUnit4ProjectModal_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "linkUnit4ProjectModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unit4Enabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a6bcbe47e8ac6a6328d86af82fdbbd6c",
    "id": null,
    "metadata": {},
    "name": "linkUnit4ProjectModal_Query",
    "operationKind": "query",
    "text": "query linkUnit4ProjectModal_Query {\n  viewer {\n    actualPersonId\n    component(name: \"link_unit4_project_modal\")\n    ...linkUnit4ProjectModal_viewer\n    id\n  }\n}\n\nfragment linkUnit4ProjectModal_viewer on Viewer {\n  id\n  company {\n    id\n    unit4Enabled\n  }\n}\n"
  }
};
})();

(node as any).hash = "844a2ef60e77d079a2d799e6a8d8210d";

export default node;
